import { type ReactNode, forwardRef } from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function createIcon(paths: ReactNode, viewBox = '0 0 24 24', displayName?: string) {
  const Icon = forwardRef<SVGSVGElement, IconProps>(
    ({ size = 24, width, height, ...props }, ref) => (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? size}
        height={height ?? size}
        viewBox={viewBox}
        fill="none"
        {...props}
      >
        {paths}
      </svg>
    )
  );

  Icon.displayName = displayName || 'Icon';
  return Icon;
}
